import { useState } from 'react';
import axios from 'axios';
import { UploadFile } from 'antd/lib/upload/interface';
import { token } from '../../../util/store';
import { IArquivoCleanDTO, IArquivoDespesaCleanDTO, IDespesaEdicaoEmLoteDTO } from '../../../models/happy-code-api.model';
import { UploadFileWithDesc } from '../CadastroDespesa/types/file-interface';

export function useUploadLote(dto: IDespesaEdicaoEmLoteDTO) {
  const [fileList, setFileList] = useState<UploadFileWithDesc[]>([]);
  const [descricaoArquivo, setDescricaoArquivo] = useState<string>('');

  const validateBeforeUpload = (file: UploadFile) => {
    const isValid = file !== undefined &&
      (file.type === 'application/pdf' ||
        file.type === 'image/jpeg' ||
        file.type === 'image/png');
    return isValid;
  };

  const uploadAll = async (): Promise<IArquivoCleanDTO[]> => {
    const pendentes = fileList.filter((f) => f.response === 'ok');
    const validos = pendentes.filter((f) => validateBeforeUpload(f.originFileObj));

    const arquivos: IArquivoCleanDTO[] = [];

    for (const f of validos) {
      const form = new FormData();
      form.append('file', f.originFileObj as any);
      form.append('descricao', f.description || '');

      const { data } = await axios.post(
        `${process.env.REACT_APP_HAPPYCODE_PUBLIC_BASE_URL_API}arquivo/upload/descricao`,
        form,
        {
          headers: { Authorization: `Bearer ${token()}` },
        }
      );
      const arquivo: IArquivoCleanDTO = {
        id: data.id,
        descricao: f.description ?? '',
        codigo: null,
        url: null,
        dataCriacao: null,
        ativo: null,
      };

      arquivos.push(arquivo);
    }

    return arquivos;
  };

  return {
    fileList,
    setFileList,
    uploadAll,
  };
}